var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('client-only',[_c('vue-progress-bar')],1),(_vm.$errorHandler && _vm.$errorHandler.statusCode >= 404 && _vm.$errorHandler.statusCode < 500)?_c('not-found'):(_vm.$errorHandler && _vm.$errorHandler.error)?_c('error-page'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }